export class UnitFormatter {
    /**
     * Format the given number with the `baseUnit`
     *
     * E.g:
     *  1.0         => 1N
     *  1.1         => 1.1N
     *  1.101       => 1.101N
     *  1_251_000   => 1,251,000N
     *  1_200_000   => 1.2MN
     *  1_250       => 1,250N
     *  1_200       => 1.2kN
     *  1_000       => 1kN
     *  1_000_000   => 1MN
     *
     * @param {number} value
     * @param {string} baseUnit
     * @return {string}
     */
    public formatNumber(value: number, baseUnit: string): string {
        let scaled;
        let multiplier;
        if (value >= 1_000_000) {
            scaled = value / 1_000_000;
            multiplier = 'M';
        } else if (value >= 1_000) {
            scaled = value / 1_000;
            multiplier = 'k';
        } else {
            scaled = value;
            multiplier = '';
        }

        const numberOfDecimals = this.getNumberOfDecimals(scaled);
        if (numberOfDecimals === 0) {
            return scaled.toLocaleString() + multiplier + baseUnit;
        } else if (numberOfDecimals === 1) {
            return scaled.toLocaleString() + multiplier + baseUnit;
        } else {
            return value.toLocaleString() + baseUnit;
        }
    }

    private getNumberOfDecimals(n: number): number {
        if (Math.floor(n.valueOf()) === n.valueOf()) {
            return 0;
        } else {
            return n.toString().split('.')[1].length || 0;
        }
    }
}
